import {Modal} from "bootstrap";
import {doAjax} from "surveylabJsAssets/common/_ajax";
import charts from "surveylabJsAssets/chart/charts";

export default function () {
    $(function () {
        initTabSections();
        filtersChevron();
        collapseFilters();
        healthAspectModal();
        printReport();
    });
}
const $dashboardParams = $('#dashboard-params');
const $dashboardUrls = $('#dashboard-urls');
const loadingSpinner = $('#loading').data('loading');
const ajaxParams = {
    serializedOrgFilter: $("#baseline-filters form").serialize(),
    waveID: $dashboardParams.data('wave-id'),
    waveLabels: $dashboardParams.data('wave-labels'),
    wavesParticipantN: $dashboardParams.data('waves-participant-n'),
}

function getHash(): string {
    return window.location.hash || $("#dashboard-tab > li > a:first-child").attr('href');
}
function initTabSections() {

    $("#dashboard-tab > li > a").on('show.bs.tab', function (e) {
        const $navLink = $(e.target);
        const hash = $navLink.attr('href');
        pushHistoryState(hash)
        loadSection(hash.substring(1));
    });
    const hash = getHash();
    if (hash) {
        loadSection(hash.substring(1));
    }

}

function pushHistoryState(hash: string) {
    // tab history saved on refresh
    history.pushState(undefined, undefined, hash);
}

function loadSection(sectionID: string) {
    const $section = $(`#${sectionID}`);
    $('#dashboard-container .filter-bar .current-wave-info').toggleClass('is-wave-comparison', $section.hasClass('is-wave-comparison'));
    const $sectionPanelList = $(`.panel-list`, $section);
    if ($sectionPanelList.html().trim() !== '') {
        return;
    }
    $sectionPanelList.html(loadingSpinner);
    ajaxParams['sectionID'] = sectionID;
    doAjax({
        url: $dashboardUrls.data('load-section'),
        data: ajaxParams,
        timeout: 20000
    }).done((response) => {
        $sectionPanelList.html(response.sectionMarkup);
        charts();
    });
}

function collapseFilters() {
    // collapse job info filters if some are selected
    $('#dashboard-container[data-user-role-id!="9"] #job-filters .form-select').each(function () {
        if ($(this).val() !== '') {
            $('#filter-toggle-btn a').trigger('click');
            $('#job-info-filters-container').collapse();
            return false;
        }
    });
}

function filtersChevron() {
    $('#filter-toggle-btn a').on('click', function (e) {
        const $icon = $('i', $(e.currentTarget));
        if ($icon.hasClass('fa-chevron-right')) {
            $icon.removeClass('fa-chevron-right').addClass('fa-chevron-down');
        } else {
            $icon.removeClass('fa-chevron-down').addClass('fa-chevron-right');
        }
    });
}
function healthAspectModal() {
    // health aspect detail modal
    const $modal = $('#health-aspect-modal');
    const modal = Modal.getOrCreateInstance(document.getElementById('health-aspect-modal'));
    let lastLoadedHealthAspectKey = null;
    $('#dashboard-container').on('click', '.show-health-aspect-btn', (e) => {
        const $showHealthAspectBtn = $(e.currentTarget);
        const $healthAspectContainer = $showHealthAspectBtn.parents('.health-aspect-chart-container');
        const healthAspectID = $healthAspectContainer.data('health-aspect-id');
        const isWaveComparison = $healthAspectContainer.hasClass('is-wave-comparison')
        const healthAspectKey = `${healthAspectID}-${isWaveComparison}`;
        modal.show();
        if (healthAspectKey === lastLoadedHealthAspectKey) {
            return;
        }
        $('.modal-body', $modal).html(loadingSpinner);
        const healthAspectName = $healthAspectContainer.data('health-aspect-title');

        ajaxParams['healthAspectID'] = healthAspectID;
        ajaxParams['isWaveComparison'] = Number(isWaveComparison);
        doAjax({
            url: $dashboardUrls.data('show-health-aspect'),
            data: ajaxParams,
            timeout: 20000
        }).done((response) => {
            lastLoadedHealthAspectKey = healthAspectKey;
            $('.modal-body', $modal).html(response.healthAspectMarkup);
            $('.health-aspect-name', $modal).text(healthAspectName);
            if (!isWaveComparison) {
                // don't show the pie charts on the detail for wave comparion
                $('.health-aspect-chart', $healthAspectContainer).clone().appendTo('#detail-chart');
                $('.detail-pdf', $healthAspectContainer).clone().appendTo('#detail-chart');
            }
            charts();
        });
    });
}

function printReport() {
    $('.controller-report-dashboard').on('click', '.export-pdf', (e) => {
        e.preventDefault();
        const hash = getHash();
        let markup = '';
        let filterTextSelector = '';
        let reportName = $(`${hash}-tab`).text();
        if ($('#health-aspect-modal').is(':visible')) {
            const $healthAspectDetail = $('#health-aspect-detail');
            markup += $healthAspectDetail.prop('outerHTML');
            const healthAspectName = $('.health-aspect-name', '#health-aspect-detail').text();
            reportName += `-${healthAspectName}`;
            filterTextSelector = '.modal-body';
        } else {
            const $sectionContainer = $(`${hash}-container`);
            markup += $sectionContainer.prop('outerHTML');
        }
        const $filterText = $(`${filterTextSelector} .filter-bar .filter-text`);
        $('#markup').val(markup);
        $('#report-name').val(reportName);
        $('#filter-text-html').val(hash == '#effect-model' ? '' : $filterText.html());
        $('#export-pdf-form').submit();
    });
}
